// extracted by mini-css-extract-plugin
module.exports = {"advertisement":"_8a8dcb","advertisement__content":"c2ae62","advertisement__content__cards-item":"_2ff20d","advertisement__content__sidebar":"_23a907"};